module.exports = __webpack_public_path__ + "img/step43.ed0cc03b.png";